import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { CategoryChild } from '@/composables/useDynamicProductListing';


export default /*#__PURE__*/_defineComponent({
  __name: 'SubCategory',
  props: {
    subCategory: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: __props.subCategory.url,
    class: "sub-category"
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.subCategory.name), 1)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})